var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRepeatTrack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.296 5.844a1 1 0 0 0 0-1.688l-2.76-1.754A1 1 0 0 0 16 3.246v3.508a1 1 0 0 0 1.537.844z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 6a4 4 0 0 0-4 4v1a1 1 0 1 1-2 0v-1a6 6 0 0 1 6-6h8a1 1 0 1 1 0 2z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.704 18.844a1 1 0 0 1 0-1.688l2.76-1.754A1 1 0 0 1 8 16.246v3.508a1 1 0 0 1-1.537.844z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 17a4 4 0 0 0 4-4v-1a1 1 0 1 1 2 0v1a6 6 0 0 1-6 6H8a1 1 0 1 1 0-2z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.45 14h-1.321V9.797l-1.297.379v-1l2.496-.863h.121z"
})));
export default SvgIcRepeatTrack;